/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Users_Form_Group_Default_DescriptionInputs */

const en_users_form_group_default_description = /** @type {(inputs: Users_Form_Group_Default_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Assign user to the ${i?.group} group.`)
};

const pt_br2_users_form_group_default_description = /** @type {(inputs: Users_Form_Group_Default_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atribuir usuário ao grupo ${i?.group}.`)
};

/**
* | output |
* | --- |
* | "Assign user to the {group} group." |
*
* @param {Users_Form_Group_Default_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_group_default_description = /** @type {((inputs: Users_Form_Group_Default_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Group_Default_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_group_default_description(inputs)
	return pt_br2_users_form_group_default_description(inputs)
});